/**
 * Component adapted from SEAC Corporate Website
 * https://github.com/oozou/seac-corporate-website/blob/v1.0.3/packages/web/src/help-center/MessageGroups.tsx
 */

import TagItems from './TagItems';
import { useMemo, useState } from 'react';
import { ThemeScheme } from './TagItems';
import { MobileDisclosure } from './QA';

const allGroup = 'All';

export interface IMessageGroup {
  messageGroups: {
    title: string;
    subGroups: ISubGroup[];
  }[];
}

export interface ISubGroup {
  description?: string;
  questionAnswerList: PairTextInput[];
}

export interface PairTextInput {
  id: string;
  firstSentence: string;
  secondSentence: string;
}

export const MessageGroups: React.FC<IMessageGroup> = ({ messageGroups }) => {
  const allGroupTitles = useMemo(() => {
    return [allGroup, ...messageGroups.map((group) => group.title)];
  }, [messageGroups]);

  const [selectedGroupTitle, setSelectedGroupTitle] = useState<string>(
    allGroupTitles[0],
  );

  const filteredGroups = useMemo(() => {
    if (selectedGroupTitle === allGroup) return messageGroups;

    return messageGroups.filter((g) => g.title === selectedGroupTitle);
  }, [messageGroups, selectedGroupTitle]);

  return (
    <div className="flex w-full justify-center">
      <div className="flex w-full max-w-screen-lg px-6">
        <div className="flex w-full flex-col">
          <div className="flex w-full flex-wrap gap-x-2 gap-y-4 py-8 lg:py-10">
            {allGroupTitles.map((group) => (
              <TagItems
                key={group}
                isCurrent={group === selectedGroupTitle}
                onClick={() => setSelectedGroupTitle(group)}
                theme={ThemeScheme.SEAC}
                name={group}
                className="border-none bg-gray-100 hover:bg-maroon-100"
              />
            ))}
          </div>
          {filteredGroups.map((group, idx) => {
            return (
              <div key={`group-${idx}`}>
                <p className="mb-4 mt-0 text-title-mobile font-bold text-brand-primary lg:mb-8 lg:mt-6 lg:text-title-desktop">
                  {group.title}
                </p>
                <div className="flex flex-col">
                  <SubGroups subGroups={group.subGroups} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const SubGroups: React.FC<{ subGroups: ISubGroup[] }> = ({ subGroups }) => {
  return (
    <>
      {subGroups.map((subGroup, subGroupIndex) => (
        <div className="mb-12" key={`subgroup-${subGroupIndex}`}>
          {subGroup.description && (
            <p className="my-4 text-heading font-bold text-brand-primary lg:my-4">
              {subGroup.description}
            </p>
          )}
          {subGroup.questionAnswerList.map((qa) => (
            <MobileDisclosure
              key={qa.id}
              listItem={{
                title: qa.firstSentence,
                description: qa.secondSentence,
                id: qa.id,
              }}
            />
          ))}
        </div>
      ))}
    </>
  );
};
